import KSteps from 'app/components/Modules/Navigation/KSteps'
import { RecordType } from 'app/constants/GlobalTypes'
import { Routes } from 'app/routes/Routes'
import { useNavigate, useParams } from 'react-router-dom'

type TypeSteps = 0 | 1 | 2 | 3

const AcceptedRoutes = Routes.Checkout.member()

const MainRoutes: Array<keyof typeof AcceptedRoutes> = [
  'address',
  'machines',
  'delivery',
  'confirmation'
]

type Props = {
  activeStep: TypeSteps
}

const CheckoutStepper = ({ activeStep }: Props) => {
  const navigate = useNavigate()
  const { checkout_id } = useParams<{ checkout_id: string }>()

  const onStepClick = (step: TypeSteps) => {
    if (step < activeStep) {
      goToPage(step)
    }
  }

  const goToPage = (step: TypeSteps) => {
    navigate(`${Routes.Checkout.member(checkout_id)[MainRoutes[step]]}`)
  }

  return (
    <KSteps
      onlyHeader
      stepsCount={4}
      recordType={RecordType.checkout}
      direction="horizontal"
      current={activeStep}
      onStepClick={onStepClick}
      className="checkout-steps"
      showTitleOnMobile={false}
    />
  )
}

export default CheckoutStepper
